import { useEffect, useState, useCallback } from "react";

import { useTable, useSortBy, usePagination, useFilters } from "react-table";

import { FaSortUp, FaSortDown, FaSort } from "react-icons/fa";

import RelatorioService from "../../../main/services/RelatorioService";
import { IoTrash } from "react-icons/io5";
import { FaHourglassHalf } from "react-icons/fa6";
import { FaDownload } from "react-icons/fa";
import { FiAlertTriangle } from "react-icons/fi";
import {
  Flex,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Text,
  Icon,
  Box,
} from "@chakra-ui/react";

import SemRegistros from "../SemRegistros";
import TablePagination from "../TablePagination";
import { isEmptyArray } from "formik";
import {
  criancaFunc,
  Permission,
  visitasFunc,
} from "../../../helpers/Funcionalidades";
import LoadingSpinner from "../LoadingSpinner";
import { useAuth } from "react-oidc-context";
import Swal from "sweetalert2";
import { cleanObject } from "../../utils/cleanObject";
import { formatDateToISOWithNow } from "../../utils/formatDateToISOWithNow";
import { parseBoolean } from "../../utils/parseBoolean";

export const TableRelatorioPendencia = (props) => {
  const { data, columns, entidade, name, setData } = props;
  const auth = useAuth();
  const token = auth?.user?.access_token;
  const [nItens, setNItens] = useState(
    JSON.parse(sessionStorage.getItem(entidade + "-filter"))?.pageSize,
  );

  const [loading, setLoading] = useState(false);
  const [shiftPressed] = useState(false);
  const [ordered, setOrdered] = useState([]);

  useEffect(() => {
    if (data?.content) {
      props?.setSelectedRows((prev) =>
        prev?.filter((id) => data?.content?.some((row) => row.id === id)),
      );
    }
  }, [data, props]);

  const nomeArquivoDownload = (headers, fallback) => {
    const disposition = headers?.["content-disposition"];
    const match = disposition?.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i);
    return match ? decodeURIComponent(match[1]) : fallback;
  };

  const getExportarExecel = (idFila, nomeRelatorio) => {
    RelatorioService.getFilaProcessamentoDownload(idFila)
      .then((res) => {
        const url = window.URL.createObjectURL(res.data);
        const link = document.createElement("a");
        link.href = url;
        link.download = nomeArquivoDownload(
          res.headers,
          `${nomeRelatorio || "relatorio"}.xlsx`,
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const formatarData = (data) => {
    if (!data) return "";
    if (data.includes("/")) {
      const [dia, mes, ano] = data.split("/");
      return `${ano}-${mes}-${dia}`;
    }
    return data;
  };

  const deleteFilaProcessamento = (idFila) => {
    Swal.fire({
      title: "Atenção!",
      text: "Deseja realmente excluir o processamento?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#169499",
      cancelButtonColor: "#169499",
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((result) => {
      if (result.isConfirmed) {
        RelatorioService.getFilaProcessamentoDelete(idFila)
          .then((res) => {
            Swal.fire({
              title: "Sucesso!",
              text: "Registro Excluído.",
              icon: "success",
              confirmButtonText: "Continuar",
              confirmButtonColor: "#169499",
            }).then((result) => {});
          })
          .catch((error) => {
            console.log(error?.response?.data);
            Swal.fire({
              title: "Atenção!",
              text: error.response.data.message
                ? error?.response?.data?.message
                : "",
              icon: "error",
              confirmButtonText: "Fechar",
              confirmButtonColor: "#169499",
            });
          })
          .finally(() => {
            props.setAtualizarDadosTabela(true);
          });
      }
    });
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    pageOptions,
    page,
    pageCount,
    prepareRow,
    canPreviousPage,
    canNextPage,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state,
    rows,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        filters: [],
        pageIndex: 0,
        sortBy: sessionStorage.getItem(`table-${entidade}`)
          ? JSON.parse(sessionStorage.getItem(`table-${entidade}`)).filter(
              (order) => order.desc !== undefined,
            )
          : [],
        pageSize: nItens,
      },
      manualPagination:
        entidade === "relatorio-pendencia" ||
        entidade === "fila-processamento" ||
        entidade === "relatorio-crianca-adolescente" ||
        entidade === "relatorio-servico-acolhimento" ||
        entidade === "relatorio-crianca-adolescente-geral"
          ? true
          : false,
      manualSortBy:
        entidade === "relatorio-pendencia" ||
        entidade === "fila-processamento" ||
        entidade === "relatorio-crianca-adolescente" ||
        entidade === "relatorio-servico-acolhimento" ||
        entidade === "relatorio-crianca-adolescente-geral"
          ? true
          : false,
      pageCount: JSON.parse(sessionStorage.getItem(entidade + "-filter"))
        ?.totalPages,
      roleKeycloack: props.roleKeycloack,
      user: props.user,
    },
    useFilters,
    useSortBy,
    usePagination,
    (hooks) => {
      if (entidade === "fila-processamento") {
        !props.disableHeaderOptionsOpcoes &&
          hooks.visibleColumns.push((columns) => [
            ...columns,
            {
              id: "options",
              Header: "Opções",
              Cell: ({ row }) => {
                const status = row?.original?.status;
                const idFila = row?.original?.id;
                const nomeRelatorio = row?.original?.nomeTipoRelatorio;

                return (
                  <>
                    <Flex alignItems="center" gap={12} py={2}>
                      {status.includes("Concluído") && (
                        <Box
                          cursor={"pointer"}
                          onClick={() =>
                            getExportarExecel(idFila, nomeRelatorio)
                          }
                        >
                          <FaDownload color="#006064" size={16} />
                        </Box>
                      )}
                      {status.includes("Aguardando") && (
                        <Box>
                          <FaHourglassHalf color="#B9690D" size={16} />
                        </Box>
                      )}
                      {status.includes("Erro") && (
                        <Box cursor={"pointer"}>
                          <FiAlertTriangle color="#A73737" size={18} />
                        </Box>
                      )}

                      {!status.includes("Aguardando") && (
                        <Box
                          cursor={"pointer"}
                          onClick={() => deleteFilaProcessamento(idFila)}
                        >
                          <IoTrash color="#6A6A6A" size={18} />
                        </Box>
                      )}
                    </Flex>
                  </>
                );
              },
            },
          ]);
      }
    },
  );

  useEffect(() => {
    if (
      entidade === "relatorio-pendencia" ||
      entidade === "fila-processamento" ||
      entidade === "relatorio-crianca-adolescente" ||
      entidade === "relatorio-servico-acolhimento" ||
      entidade === "relatorio-crianca-adolescente-geral"
    ) {
      const pageSize = JSON.parse(
        sessionStorage.getItem(entidade + "-filter"),
      )?.pageSize;
      if (pageSize) {
        setNItens(pageSize);
      }
    } else {
      if (sessionStorage.getItem(entidade + "-pagination-count")) {
        setNItens(
          parseInt(sessionStorage.getItem(entidade + "-pagination-count")),
        );
      }
    }
  }, [entidade, props?.index]);

  useEffect(() => {
    if (
      entidade === "relatorio-pendencia" ||
      entidade === "fila-processamento" ||
      entidade === "relatorio-crianca-adolescente" ||
      entidade === "relatorio-servico-acolhimento" ||
      entidade === "relatorio-crianca-adolescente-geral"
    ) {
      const storage = sessionStorage.getItem(entidade + "-filter");
      const tempPage = JSON.parse(storage)?.page;
      if (tempPage && tempPage <= pageCount) {
        gotoPage(tempPage);
      }
    } else {
      if (sessionStorage.getItem(entidade + "-pagination-page")) {
        const tempPage = Number(
          sessionStorage.getItem(entidade + "-pagination-page"),
        );
        if (tempPage <= pageCount) {
          gotoPage(tempPage);
        }
      }
    }
  }, [state, entidade, gotoPage, pageCount, props?.index]);

  const selecionarOrdenacao = useCallback(
    (sort) => {
      const tempObj =
        JSON.parse(sessionStorage.getItem(entidade + "-filter")) || {};
      tempObj.page = 0;
      tempObj.sort = sort.id;
      tempObj.desc = sort.desc;

      if (entidade === "relatorio-pendencia") {
        setLoading(true);

        const storageValues = {
          municipioId: tempObj?.municipioId ? tempObj.municipioId.id : "",
          promocaoId: tempObj?.promocaoId ? tempObj.promocaoId.id : "",
          tipoRelatorio: tempObj?.tipoRelatorio
            ? tempObj.tipoRelatorio.value
            : "",
          servicoAtendimentoId: tempObj?.servicoAtendimentoId
            ? tempObj.servicoAtendimentoId.id
            : "",
          dataReferencia: tempObj?.dataReferencia
            ? formatDateToISOWithNow(tempObj.dataReferencia)
            : "",
          pageSize: tempObj?.pageSize,
          page: tempObj?.page,
          ...(sort?.desc !== undefined
            ? {
                sortField: sort.id,
                sortType: sort.desc ? "DESC" : "ASC",
              }
            : {}),
        };

        let pesquisarFn =
          storageValues.tipoRelatorio ===
          "RELATORIO_PENDENCIAS_SERVICOS_ACOLHIMENTO"
            ? RelatorioService.getRelatorioPendenciaServico
            : RelatorioService.getRelatorioPendenciaCrianca;

        pesquisarFn(token, storageValues).then((res) => {
          sessionStorage.setItem(
            entidade + "-filter",
            JSON.stringify({
              ...tempObj,
              totalItems: res.data.totalElements,
              totalPages: res.data.totalPages,
            }),
          );

          setData(res.data);
          setLoading(false);
        });
      } else if (entidade === "fila-processamento") {
        setLoading(true);

        const storageValues = {
          nomeResponsavel: tempObj?.nomeResponsavel
            ? tempObj.nomeResponsavel.id
            : "",
          statusRelatorio: tempObj?.statusRelatorio
            ? tempObj.statusRelatorio
            : "",
          tipoRelatorio: tempObj?.tipoRelatorio ? tempObj.tipoRelatorio : "",
          pageSize: tempObj?.pageSize,
          page: tempObj?.page,
          ...(sort?.desc !== undefined
            ? {
                sortField: sort.id,
                sortType: sort.desc ? "DESC" : "ASC",
              }
            : {}),
        };

        RelatorioService.getFilaProcessamento(token, storageValues).then(
          (res) => {
            sessionStorage.setItem(
              entidade + "-filter",
              JSON.stringify({
                ...tempObj,
                totalItems: res.data.totalElements,
                totalPages: res.data.totalPages,
              }),
            );

            setData(res.data);
            setLoading(false);
          },
        );
      } else if (entidade === "relatorio-crianca-adolescente") {
        setLoading(true);

        const idsServicoAcolhimentoChange = props.roleKeycloack.includes(
          criancaFunc.visualizarTudoAcolhimento,
        )
          ? [tempObj?.idsServicosAcolhimento.value]
          : Array.isArray(tempObj?.idsServicosAcolhimento)
            ? tempObj.idsServicosAcolhimento
                .flat()
                .map((item) => item.value)
                .filter((value) => value !== "")
            : [];

        const storageValues = {
          universoConsulta: tempObj?.universoConsulta
            ? tempObj.universoConsulta.label
                ?.normalize("NFD")
                ?.replace(/[\u0300-\u036f]/g, "")
                ?.toUpperCase()
            : "",
          idsServicosAcolhimento: tempObj?.idsServicosAcolhimento
            ? idsServicoAcolhimentoChange
            : [],
          dataInicio: tempObj?.dataInicio
            ? formatarData(tempObj.dataInicio)
            : "",
          dataFim: tempObj?.dataFim ? formatarData(tempObj.dataFim) : "",
          idsMotivosEntrada: tempObj?.idsMotivosEntrada
            ? tempObj.idsMotivosEntrada
                .flat()
                .map((item) => item.id)
                .filter((id) => id !== "")
            : [],
          idTipoTransferencia: tempObj?.idTipoTransferencia
            ? tempObj.idTipoTransferencia.id
            : "",
          idJustificativas: tempObj?.idJustificativas
            ? tempObj?.idJustificativas
                .flat()
                .map((item) => item.id)
                .filter((id) => id !== "")
            : [],

          tipoPeriodo: tempObj?.tipoPeriodo === "A" ? "SITUACAO_ATUAL" : "DATA",
          entradasPorTransferencias:
            Array.isArray(tempObj?.entradasPorTransferencias) &&
            tempObj.entradasPorTransferencias.includes("Possui"),

          maioresDezoito:
            Array.isArray(tempObj?.maioresDezoito) &&
            tempObj.maioresDezoito.includes("Possui"),
          saidaTransferencia:
            Array.isArray(tempObj?.saidaTransferencia) &&
            tempObj.saidaTransferencia.includes("Possui"),
          pageSize: tempObj?.pageSize,
          page: tempObj?.page,
          ...(sort?.desc !== undefined
            ? {
                sortField: sort.id,
                sortType: sort.desc ? "DESC" : "ASC",
              }
            : {}),
        };

        let pesquisarFn = RelatorioService.getRelatorioCrianca;

        pesquisarFn(token, storageValues).then((res) => {
          sessionStorage.setItem(
            entidade + "-filter",
            JSON.stringify({
              ...tempObj,
              totalItems: res.data.totalElements,
              totalPages: res.data.totalPages,
            }),
          );

          setData(res.data);
          setLoading(false);
        });
      } else if (entidade === "relatorio-crianca-adolescente-geral") {
        setLoading(true);

        const idsProcesso = (tempObj?.idProcesso || [])
          ?.flat()
          ?.map((item) => item.id)
          ?.filter(Boolean);
        const idsTipoSentenca = (tempObj?.idTipoSentenca || [])
          ?.flat()
          ?.map((item) => item.id)
          ?.filter(Boolean);
        const idsProcedimento = (tempObj?.idProcedimento || [])
          ?.flat()
          ?.map((item) => item.id)
          ?.filter(Boolean);

        const idsDeficiencias = tempObj?.deficiencias
          ? (() => {
              const flat = tempObj?.deficiencias.flat();

              const hasTodos = flat.some((item) => item.id === "");

              if (hasTodos) return [0];

              return flat
                .map((item) => item.idTipoDeficiencia ?? item.value)
                .filter((id) => id !== null && id !== undefined && id !== "");
            })()
          : [];

        const idsDoencas = tempObj?.doencas
          ? (() => {
              const flat = tempObj?.doencas.flat();

              const hasTodos = flat.some((item) => item.id === "");

              if (hasTodos) return [0];

              return flat
                .map((item) => item.idDoenca ?? item.value)
                .filter((id) => id !== null && id !== undefined && id !== "");
            })()
          : [];

        const generos = (tempObj?.idGenero || [])
          ?.flat()
          ?.map((item) => item.id)
          ?.filter(Boolean);

        const racas = (tempObj?.idRaca || [])
          ?.flat()
          ?.map((item) => item.id)
          ?.filter(Boolean);

        const idTipoRef = tempObj?.idTipoReferencia
          ? (() => {
              const flat = tempObj?.idTipoReferencia.flat();

              const hasTodos = flat.some((item) => item.id === "");

              if (hasTodos) return [0];

              return flat
                .map((item) => item.id ?? item.value)
                .filter((id) => id !== null && id !== undefined && id !== "");
            })()
          : [];

        const nomeServicosAcolhimentos = (tempObj?.idsServicosAcolhimento || [])
          ?.flat()
          ?.map((item) => item.nomeFantasia)
          ?.filter(Boolean);

        const idsJustificativas = (tempObj?.idJustificativas || [])
          ?.flat()
          ?.map((item) => item.id)
          ?.filter(Boolean);

        const idsMotivo = (tempObj?.idsMotivosEntrada || [])
          ?.flat()
          ?.map((item) => item.id)
          ?.filter(Boolean);
        const idsServicos = (tempObj?.idsServicosAcolhimento || [])
          ?.flat()
          ?.map((item) => item.id)
          ?.filter(Boolean);
        const municipiosOrgaos = (tempObj?.idMunicipioOrgao || [])
          ?.flat()
          ?.map((item) => item.id)
          ?.filter((id) => id !== "" && id != null);
        const promotoriasOrgaos = (tempObj?.idPromotoriaOrgaos || [])
          ?.flat()
          ?.map((item) => ({
            id: item.id,
            idMunicipio: item.idMunicipio,
          }))
          ?.filter((id) => id !== "" && id != null);
        const varasOrgaos = (tempObj?.idVaraOrgaos || [])
          ?.flat()
          ?.map((item) => ({
            id: item.id,
            idMunicipio: item.idMunicipio,
          }))
          ?.filter((id) => id !== "" && id != null);

        const idadeMin = [tempObj?.idadeInicial].find(
          (v) => v != null && v !== "" && v !== "null",
        );

        const idadeMax = [tempObj?.idadeFinal].find(
          (v) => v != null && v !== "" && v !== "null",
        );

        const storageValues = {
          universoConsulta: {
            universo:
              tempObj?.universoConsulta === 1
                ? "ACOLHIDO"
                : tempObj?.universoConsulta === 2
                  ? "DESLIGADO"
                  : tempObj?.universoConsulta === 3
                    ? "TRANSFERENCIA"
                    : "PENDENTE",
            idsServicosAcolhimento: idsServicos,
            idsMotivosEntrada: idsMotivo,
            tipoPeriodo:
              tempObj?.tipoPeriodo === "A"
                ? "SITUACAO_ATUAL"
                : tempObj?.tipoPeriodo === "D"
                  ? "DATA"
                  : "",

            entradasPorTransferencias:
              tempObj?.entradasPorTransferencias?.includes("Possui")
                ? true
                : false,
            saidaTransferencia: tempObj?.saidaTransferencia?.includes("Possui")
              ? true
              : false,
            maioresDezoito: tempObj?.maioresDezoito?.includes("Possui")
              ? true
              : false,
            dataInicio: tempObj?.dataInicio
              ? formatDateToISOWithNow(tempObj?.dataInicio)
              : "",
            dataFim: tempObj?.dataFim
              ? formatDateToISOWithNow(tempObj?.dataFim)
              : "",
            idJustificativas: idsJustificativas,
            idTipoTransferencia: tempObj?.idTipoTransferencia?.id
              ? tempObj?.idTipoTransferencia?.id
              : null,
          },

          localizacaoServicoAcolhimento: {
            estados: tempObj?.idEstado
              ? tempObj?.idEstado
                  .flat()
                  .map((item) => item.id)
                  .filter((item) => item.id !== "")
              : [],
            municipios: tempObj?.idMunicipio
              ? tempObj?.idMunicipio
                  .flat()
                  .map((item) => ({
                    id: item.id,
                    idEstado: item.idEstado,
                  }))
                  .filter((item) => item.id !== "")
              : [],
            bairros: tempObj?.idBairro
              ? tempObj?.idBairro
                  .flat()
                  .map((item) => ({
                    id: item.id,
                    idMunicipio: item.idMunicipio,
                  }))
                  .filter((item) => item.id !== "")
              : [],
            nomeServicosAcolhimentos: nomeServicosAcolhimentos,
          },

          orgaos: cleanObject({
            municipios: municipiosOrgaos,
            promotorias: promotoriasOrgaos,
            varasInfancias: varasOrgaos,
            orgaoConstaFichaCriancaAdoslecente:
              tempObj?.radioCriterioAtribuicaoCompetencia === "C" ? true : "",
            orgaoConstaFichaServicoAcolhimento:
              tempObj?.radioCriterioAtribuicaoCompetencia === "S" ? true : "",
            mesmoOrgaoFichaCriancaAdoslecenteEFichaServicoAcolhimento:
              tempObj?.radioCriterioAtribuicaoCompetencia === "CS" ? true : "",
          }),

          dadosBasicos: cleanObject({
            generos: generos,
            racasCores: racas,
            faixaEtariaDe: idadeMin,
            faixaEtariaAte: idadeMax,
            comNomeSocial: tempObj?.pesquisarFichas?.includes("S") ? true : "",
            comNomeFicticio: tempObj?.pesquisarFichas?.includes("F")
              ? true
              : "",
            comDataNascimentoEstimada: tempObj?.pesquisarFichas?.includes("N")
              ? true
              : "",
          }),
          referenciaFamiliarComunitaria: cleanObject({
            tiposReferencia: idTipoRef,
            nomeReferencia: tempObj?.nomeReferencia,
            irmaosMesmoServico: tempObj?.detalhamentoIrmaos?.includes("A")
              ? true
              : "",
            irmaosServicosDiferentes: tempObj?.detalhamentoIrmaos?.includes(
              "AD",
            )
              ? true
              : "",
            irmaosSemHistoricoAcolhimento:
              tempObj?.detalhamentoIrmaos?.includes("H") ? true : "",
            irmaosDesligados: tempObj?.detalhamentoIrmaos?.includes("D")
              ? true
              : "",
          }),
          saude: cleanObject({
            possuiDeficiencia: parseBoolean(tempObj?.radioDeficiencia),
            tiposDeficiencia: idsDeficiencias,
            possuiProblemaSaude: parseBoolean(tempObj?.radioProblemaSaude),
            tiposDoenca: idsDoencas,
            cartaoVacinacao:
              tempObj?.radioCartaoVacinacao.length > 0
                ? tempObj?.radioCartaoVacinacao
                : [],
            usaMedicacaoContinua: parseBoolean(tempObj?.radioMedicacaoContinua),
          }),
          educacao: cleanObject({
            frequentaEscola: parseBoolean(tempObj?.radioFrequentaEscola),
            educacaoEspecial: parseBoolean(tempObj?.radioEducacaoEspecial),
            escolaridadeRepetida: parseBoolean(
              tempObj?.radioEscolaridadeRepetida,
            ),
          }),
          profissionalizacao: cleanObject({
            possuiCursoProfissionalizante: parseBoolean(
              tempObj?.radioPossuiCurso,
            ),
            trabalhaAtualmente: parseBoolean(tempObj?.radioTrabalhaAtualmente),
            fazEstagio: parseBoolean(tempObj?.radioFazEstagio),
            matriculadoJovemAprendiz: parseBoolean(tempObj?.radioJovemAprendiz),
            possuiCurriculoVitae: parseBoolean(tempObj?.radioCurriculoVitae),
          }),

          ...(tempObj?.radioRecebeVisita &&
            typeof tempObj?.radioRecebeVisita === "string" && {
              visita: cleanObject({
                recebeVisita: parseBoolean(tempObj?.radioRecebeVisita),
                faixaPeriodo:
                  tempObj?.faixaPeriodo?.id === 1
                    ? "NO_MES"
                    : tempObj?.faixaPeriodo?.id === 2
                      ? "ULTIMOS_3_MESES"
                      : tempObj?.faixaPeriodo?.id === 3
                        ? "ULTIMOS_6_MESES"
                        : tempObj?.faixaPeriodo?.id === 4
                          ? "EM_QUALQUER_PERIODO"
                          : "EM_QUALQUER_PERIODO",
              }),
            }),

          situacaoJuridica: cleanObject({
            possuiProcessoJudicial: parseBoolean(
              tempObj?.radioPossuiProcessoJudicial,
            ),
            tiposProcesso: idsProcesso,
            possuiProcedimentoJudicial: parseBoolean(
              tempObj?.radioPossuiProcedimentoJudicial,
            ),
            tiposProcedimento: idsProcedimento,
            haDecisaoLiminarFamiliaSubstituta: parseBoolean(
              tempObj?.radioDecisaoLiminar,
            ),
            possuiSentenca: parseBoolean(tempObj?.radioSentenca),
            tiposSentenca: idsTipoSentenca,
            recurso:
              tempObj?.radioRecurso === "S"
                ? "S"
                : tempObj?.radioRecurso === "N"
                  ? "N"
                  : tempObj?.radioRecurso === "I"
                    ? "I"
                    : "",
            transitoEmJulgado: parseBoolean(tempObj?.radioTransitoJulgado),
          }),
          situacaoAdocao: {
            cumpreRequisitosAdocao: parseBoolean(tempObj?.radioCumpreRequisito),
          },

          ...(tempObj?.radioIncluidoPrograma &&
            typeof tempObj?.radioIncluidoPrograma === "string" && {
              programaApadrinhamento: cleanObject({
                incluidoProgramaApadrinhamento:
                  tempObj?.radioIncluidoPrograma === "S"
                    ? "SIM"
                    : tempObj?.radioIncluidoPrograma === "N"
                      ? "NAO"
                      : tempObj?.radioIncluidoPrograma === "SI"
                        ? "SEM_INFORMACAO"
                        : "",
                sendoApadrinhado:
                  tempObj?.radioSendoApadrinhado === "S"
                    ? "SIM"
                    : tempObj?.radioSendoApadrinhado === "N"
                      ? "NAO"
                      : tempObj?.radioSendoApadrinhado === "SI"
                        ? "SEM_INFORMACAO"
                        : "",
              }),
            }),
          pageSize: tempObj?.pageSize,
          page: tempObj?.page,
          ...(sort?.desc !== undefined
            ? {
                sortField: sort.id,
                sortType: sort.desc ? "DESC" : "ASC",
              }
            : {}),
        };

        let pesquisarFn = RelatorioService.getRelatorioCriancaGeral;

        pesquisarFn(storageValues).then((res) => {
          sessionStorage.setItem(
            entidade + "-filter",
            JSON.stringify({
              ...tempObj,
              totalItems: res.data.totalElements,
              totalPages: res.data.totalPages,
            }),
          );

          setData(res.data);
          setLoading(false);
        });
      } else if (entidade === "relatorio-servico-acolhimento") {
        setLoading(true);

        const statusMap = {
          A: "ATIVO",
          D: "DESATIVADO",
          S: "SUSPENSO",
        };
        const status = tempObj?.statusRelatorio.map((item) => statusMap[item]);
        const generos = (tempObj?.idGenero || [])
          ?.flat()
          ?.map((item) => item.genero)
          ?.filter(Boolean);
        const nomeServicosAcolhimentos = (tempObj?.idsServicosAcolhimento || [])
          ?.flat()
          ?.map((item) => item.nomeFantasia)
          ?.filter(Boolean);
        const municipiosOrgaos = (tempObj?.idMunicipioOrgao || [])
          ?.flat()
          ?.map((item) => item.id)
          ?.filter((id) => id !== "" && id != null);
        const promotoriasOrgaos = (tempObj?.idPromotoriaOrgaos || [])
          ?.flat()
          ?.map((item) => ({
            id: item.id,
            idMunicipio: item.idMunicipio,
          }))
          ?.filter((id) => id !== "" && id != null);
        const varasOrgaos = (tempObj?.idVaraOrgaos || [])
          ?.flat()
          ?.map((item) => ({
            id: item.id,
            idMunicipio: item.idMunicipio,
          }))
          ?.filter((id) => id !== "" && id != null);
        const naturezas = (tempObj?.naturezaServico || [])
          ?.flat()
          ?.map((item) => item?.id?.toUpperCase())
          ?.filter((id) => id !== "" && id != null);
        const regimes = (tempObj?.regime || [])
          ?.flat()
          ?.map((item) => item.id)
          ?.filter((id) => id !== "" && id != null);
        const modalidades = (tempObj?.modalidade || [])
          ?.flat()
          ?.map((item) => item.descricao)
          ?.filter(Boolean);

        const SAF =
          Array.isArray(tempObj?.regime) &&
          tempObj?.regime?.flat()?.some((item) => item.id === "SAF");

        const idadeMin = [tempObj?.idadeInicial, tempObj?.idadeMinima].find(
          (v) => v != null && v !== "" && v !== "null",
        );

        const idadeMax = [tempObj?.idadeFinal, tempObj?.idadeMaxima].find(
          (v) => v != null && v !== "" && v !== "null",
        );

        const storageValues = {
          status: status,
          localizacaoServicoAcolhimento: {
            estados: tempObj?.idEstado
              ? tempObj?.idEstado
                  .flat()
                  .map((item) => item.id)
                  .filter((item) => item.id !== "")
              : [],
            municipios: tempObj?.idMunicipio
              ? tempObj?.idMunicipio
                  .flat()
                  .map((item) => ({
                    id: item.id,
                    idEstado: item.idEstado,
                  }))
                  .filter((item) => item.id !== "")
              : [],
            bairros: tempObj?.idBairro
              ? tempObj?.idBairro
                  .flat()
                  .map((item) => ({
                    id: item.id,
                    idMunicipio: item.idMunicipio,
                  }))
                  .filter((item) => item.id !== "")
              : [],
            nomeServicosAcolhimentos: nomeServicosAcolhimentos,
          },
          orgaos: {
            municipios: municipiosOrgaos,
            promotorias: promotoriasOrgaos,
            varasInfancias: varasOrgaos,
          },
          caracterizacaoServicoAcolhimento: {
            regimes: regimes,
            modalidades:
              SAF &&
              !modalidades.includes("Não se aplica") &&
              modalidades?.length > 0
                ? [...modalidades, "Não se aplica"]
                : modalidades,
            naturezas: naturezas,
          },
          perfilAtendimento: {
            ...(tempObj?.radioGenero && {
              tipoGenero:
                tempObj.radioGenero === "AS"
                  ? "ATENDE"
                  : tempObj.radioGenero === "SR"
                    ? "SEM_RESTRICAO"
                    : tempObj.radioGenero === "NA"
                      ? "NAO_ATENDE"
                      : "",
            }),

            generos: generos.length > 0 ? generos : [],

            ...(tempObj?.radioFaixaEtaria && {
              restricao:
                tempObj.radioFaixaEtaria === "TO"
                  ? "TODOS"
                  : tempObj.radioFaixaEtaria === "AT"
                    ? "ATENDE"
                    : tempObj.radioFaixaEtaria === "CR"
                      ? "COM_RESTRICAO"
                      : "",
            }),

            ...(idadeMin && {
              idadeMinima: Number(idadeMin),
            }),

            ...(idadeMax && {
              idadeMaxima: Number(idadeMax),
            }),

            restricaoDeficiencia:
              tempObj?.radioSaudeCriancaDeficiencia?.length > 0
                ? tempObj?.radioSaudeCriancaDeficiencia
                : [],

            restricaoSubstancias:
              tempObj?.radioSaudeSubstanciasPsicoativas?.length > 0
                ? tempObj?.radioSaudeSubstanciasPsicoativas
                : [],

            restricaoCuidados:
              tempObj?.radioSaudeCriancaCuidados?.length > 0
                ? tempObj?.radioSaudeCriancaCuidados
                : [],
          },

          regularidade: {
            registroCMDCA: tempObj?.registroCMDCA ? tempObj?.registroCMDCA : [],
            registroValidoCMDCA: tempObj?.registroValidoCMDCA
              ? tempObj?.registroValidoCMDCA
              : [],
            inscricaoCMDCA: tempObj?.inscricaoCMDCA
              ? tempObj?.inscricaoCMDCA
              : [],
            inscricaoValidaCMDCA: tempObj?.inscricaoValidaCMDCA
              ? tempObj?.inscricaoValidaCMDCA
              : [],
            inscricaoCMAS: tempObj?.inscricaoCMAS ? tempObj?.inscricaoCMAS : [],
            inscricaoValidaCMAS: tempObj?.inscricaoValidaCMAS
              ? tempObj?.inscricaoValidaCMAS
              : [],
          },

          planejamento: {
            possuiPlanoTrabalho: tempObj?.possuiPlano
              ? tempObj?.possuiPlano
              : [],
            possuiProjetoPoliticoPedagogico: tempObj?.possuiProjeto
              ? tempObj?.possuiProjeto
              : [],
            possuiRelatorioAnual: tempObj?.possuiRelatorio
              ? tempObj?.possuiRelatorio
              : [],
            possuiRegimentoInterno: tempObj?.possuiRegimento
              ? tempObj?.possuiRegimento
              : [],
          },

          possuiAcessoMCA: tempObj?.possuiAcessoMCA
            ? tempObj?.possuiAcessoMCA
            : [],
          possuiVoluntariado: tempObj?.possuiVoluntariado
            ? tempObj?.possuiVoluntariado
            : [],

          apadrinhamento: {
            mantemProgramaApadrinhamento: tempObj?.mantemPrograma
              ? tempObj?.mantemPrograma
              : [],
            inscritoCMDCA: tempObj?.encontraInscritoCMDCA
              ? tempObj?.encontraInscritoCMDCA
              : [],
          },

          ...((tempObj?.possuiVaga === "S" || tempObj?.possuiVaga === "N") && {
            vagasDisponiveis: tempObj?.possuiVaga === "S",
          }),
          pageSize: tempObj?.pageSize,
          page: tempObj?.page,
          ...(sort?.desc !== undefined
            ? {
                sortField: sort.id,
                sortType: sort.desc ? "DESC" : "ASC",
              }
            : {}),
        };

        let pesquisarFn = RelatorioService.getRelatorioServicoAcolhimento;

        pesquisarFn(storageValues).then((res) => {
          sessionStorage.setItem(
            entidade + "-filter",
            JSON.stringify({
              ...tempObj,
              totalItems: res.data.totalElements,
              totalPages: res.data.totalPages,
            }),
          );

          setData(res.data);
          setLoading(false);
        });
      }
    },
    [entidade, setData, token, props.roleKeycloack],
  );

  function irParaPagina(pagina) {
    if (entidade === "relatorio-pendencia") {
      setLoading(true);
      let tempObj = JSON.parse(sessionStorage.getItem(entidade + "-filter"));
      tempObj.page = pagina;
      sessionStorage.setItem(entidade + "-filter", JSON.stringify(tempObj));

      const storageValues = {
        municipioId: tempObj?.municipioId ? tempObj.municipioId.id : "",
        promocaoId: tempObj?.promocaoId ? tempObj.promocaoId.id : "",
        tipoRelatorio: tempObj?.tipoRelatorio
          ? tempObj.tipoRelatorio.value
          : "",
        servicoAtendimentoId: tempObj?.servicoAtendimentoId
          ? tempObj.servicoAtendimentoId.id
          : "",
        dataReferencia: tempObj?.dataReferencia
          ? formatDateToISOWithNow(tempObj.dataReferencia)
          : "",
        pageSize: tempObj?.pageSize,
        page: pagina,
        ...(tempObj?.desc !== undefined
          ? {
              sortField: tempObj.sort,
              sortType: tempObj.desc ? "DESC" : "ASC",
            }
          : {}),
      };

      let pesquisarFn =
        storageValues.tipoRelatorio ===
        "RELATORIO_PENDENCIAS_SERVICOS_ACOLHIMENTO"
          ? RelatorioService.getRelatorioPendenciaServico
          : RelatorioService.getRelatorioPendenciaCrianca;

      pesquisarFn(token, storageValues).then((res) => {
        sessionStorage.setItem(
          entidade + "-filter",
          JSON.stringify({
            ...tempObj,
            totalItems: res.data.totalElements,
            totalPages: res.data.totalPages,
          }),
        );

        setData(res.data);
        setLoading(false);
      });
    } else if (entidade === "fila-processamento") {
      setLoading(true);
      let tempObj = JSON.parse(sessionStorage.getItem(entidade + "-filter"));
      tempObj.page = pagina;
      sessionStorage.setItem(entidade + "-filter", JSON.stringify(tempObj));

      const storageValues = {
        nomeResponsavel: tempObj?.nomeResponsavel
          ? tempObj.nomeResponsavel.id
          : "",
        statusRelatorio: tempObj?.statusRelatorio
          ? tempObj.statusRelatorio
          : "",
        tipoRelatorio: tempObj?.tipoRelatorio ? tempObj.tipoRelatorio : "",
        pageSize: tempObj?.pageSize,
        page: pagina,
        ...(tempObj?.sortType !== undefined
          ? {
              sortType: tempObj.sortType ?? "DESC",
            }
          : {}),
      };

      RelatorioService.getFilaProcessamento(token, storageValues).then(
        (res) => {
          sessionStorage.setItem(
            entidade + "-filter",
            JSON.stringify({
              ...tempObj,
              totalItems: res.data.totalElements,
              totalPages: res.data.totalPages,
            }),
          );

          setData(res.data);
          setLoading(false);
        },
      );
    } else if (entidade === "relatorio-crianca-adolescente") {
      setLoading(true);
      let tempObj = JSON.parse(sessionStorage.getItem(entidade + "-filter"));
      tempObj.page = pagina;
      sessionStorage.setItem(entidade + "-filter", JSON.stringify(tempObj));

      const idsServicoAcolhimentoChange = props.roleKeycloack.includes(
        criancaFunc.visualizarTudoAcolhimento,
      )
        ? [tempObj?.idsServicosAcolhimento.value]
        : Array.isArray(tempObj?.idsServicosAcolhimento)
          ? tempObj.idsServicosAcolhimento
              .flat()
              .map((item) => item.value)
              .filter((value) => value !== "")
          : [];

      const storageValues = {
        universoConsulta: tempObj?.universoConsulta
          ? tempObj.universoConsulta.label
              ?.toUpperCase()
              ?.normalize("NFD")
              ?.replace(/[\u0300-\u036f]/g, "")
              ?.toUpperCase()
          : "",
        idsServicosAcolhimento: tempObj?.idsServicosAcolhimento
          ? idsServicoAcolhimentoChange
          : [],
        dataInicio: tempObj?.dataInicio ? formatarData(tempObj.dataInicio) : "",
        dataFim: tempObj?.dataFim ? formatarData(tempObj.dataFim) : "",
        idsMotivosEntrada: tempObj?.idsMotivosEntrada
          ? tempObj.idsMotivosEntrada
              .flat()
              .map((item) => item.id)
              .filter((id) => id !== "")
          : "",
        idTipoTransferencia: tempObj?.idTipoTransferencia
          ? tempObj.idTipoTransferencia.id
          : "",
        idJustificativas: tempObj?.idJustificativas
          ? tempObj?.idJustificativas
              .flat()
              .map((item) => item.id)
              .filter((id) => id !== "")
          : "",

        tipoPeriodo: tempObj?.tipoPeriodo === "A" ? "SITUACAO_ATUAL" : "DATA",
        entradasPorTransferencias:
          Array.isArray(tempObj?.entradasPorTransferencias) &&
          tempObj.entradasPorTransferencias.includes("Possui"),

        maioresDezoito:
          Array.isArray(tempObj?.maioresDezoito) &&
          tempObj.maioresDezoito.includes("Possui"),
        saidaTransferencia:
          Array.isArray(tempObj?.saidaTransferencia) &&
          tempObj.saidaTransferencia.includes("Possui"),
        pageSize: tempObj?.pageSize,
        page: pagina,
        ...(tempObj?.desc !== undefined
          ? {
              sortField: tempObj.sort,
              sortType: tempObj.desc ? "DESC" : "ASC",
            }
          : {}),
      };

      let pesquisarFn = RelatorioService.getRelatorioCrianca;

      pesquisarFn(token, storageValues).then((res) => {
        sessionStorage.setItem(
          entidade + "-filter",
          JSON.stringify({
            ...tempObj,
            totalItems: res.data.totalElements,
            totalPages: res.data.totalPages,
          }),
        );

        setData(res.data);
        setLoading(false);
      });
    } else if (entidade === "relatorio-crianca-adolescente-geral") {
      setLoading(true);
      let tempObj = JSON.parse(sessionStorage.getItem(entidade + "-filter"));
      tempObj.page = pagina;
      sessionStorage.setItem(entidade + "-filter", JSON.stringify(tempObj));

      const idsProcesso = (tempObj?.idProcesso || [])
        ?.flat()
        ?.map((item) => item.id)
        ?.filter(Boolean);
      const idsTipoSentenca = (tempObj?.idTipoSentenca || [])
        ?.flat()
        ?.map((item) => item.id)
        ?.filter(Boolean);
      const idsProcedimento = (tempObj?.idProcedimento || [])
        ?.flat()
        ?.map((item) => item.id)
        ?.filter(Boolean);

      const idsDeficiencias = tempObj?.deficiencias
        ? (() => {
            const flat = tempObj?.deficiencias.flat();

            const hasTodos = flat.some((item) => item.id === "");

            if (hasTodos) return [0];

            return flat
              .map((item) => item.idTipoDeficiencia ?? item.value)
              .filter((id) => id !== null && id !== undefined && id !== "");
          })()
        : [];

      const idsDoencas = tempObj?.doencas
        ? (() => {
            const flat = tempObj?.doencas.flat();

            const hasTodos = flat.some((item) => item.id === "");

            if (hasTodos) return [0];

            return flat
              .map((item) => item.idDoenca ?? item.value)
              .filter((id) => id !== null && id !== undefined && id !== "");
          })()
        : [];

      const generos = (tempObj?.idGenero || [])
        ?.flat()
        ?.map((item) => item.id)
        ?.filter(Boolean);

      const racas = (tempObj?.idRaca || [])
        ?.flat()
        ?.map((item) => item.id)
        ?.filter(Boolean);

      const idTipoRef = tempObj?.idTipoReferencia
        ? (() => {
            const flat = tempObj?.idTipoReferencia.flat();

            const hasTodos = flat.some((item) => item.id === "");

            if (hasTodos) return [0];

            return flat
              .map((item) => item.id ?? item.value)
              .filter((id) => id !== null && id !== undefined && id !== "");
          })()
        : [];

      const nomeServicosAcolhimentos = (tempObj?.idsServicosAcolhimento || [])
        ?.flat()
        ?.map((item) => item.nomeFantasia)
        ?.filter(Boolean);

      const idsJustificativas = (tempObj?.idJustificativas || [])
        ?.flat()
        ?.map((item) => item.id)
        ?.filter(Boolean);

      const idsMotivo = (tempObj?.idsMotivosEntrada || [])
        ?.flat()
        ?.map((item) => item.id)
        ?.filter(Boolean);
      const idsServicos = (tempObj?.idsServicosAcolhimento || [])
        ?.flat()
        ?.map((item) => item.id)
        ?.filter(Boolean);
      const municipiosOrgaos = (tempObj?.idMunicipioOrgao || [])
        ?.flat()
        ?.map((item) => item.id)
        ?.filter((id) => id !== "" && id != null);
      const promotoriasOrgaos = (tempObj?.idPromotoriaOrgaos || [])
        ?.flat()
        ?.map((item) => ({
          id: item.id,
          idMunicipio: item.idMunicipio,
        }))
        ?.filter((id) => id !== "" && id != null);
      const varasOrgaos = (tempObj?.idVaraOrgaos || [])
        ?.flat()
        ?.map((item) => ({
          id: item.id,
          idMunicipio: item.idMunicipio,
        }))
        ?.filter((id) => id !== "" && id != null);

      const idadeMin = [tempObj?.idadeInicial].find(
        (v) => v != null && v !== "" && v !== "null",
      );

      const idadeMax = [tempObj?.idadeFinal].find(
        (v) => v != null && v !== "" && v !== "null",
      );

      const storageValues = {
        universoConsulta: {
          universo:
            tempObj?.universoConsulta === 1
              ? "ACOLHIDO"
              : tempObj?.universoConsulta === 2
                ? "DESLIGADO"
                : tempObj?.universoConsulta === 3
                  ? "TRANSFERENCIA"
                  : "PENDENTE",
          idsServicosAcolhimento: idsServicos,
          idsMotivosEntrada: idsMotivo,
          tipoPeriodo:
            tempObj?.tipoPeriodo === "A"
              ? "SITUACAO_ATUAL"
              : tempObj?.tipoPeriodo === "D"
                ? "DATA"
                : "",

          entradasPorTransferencias:
            tempObj?.entradasPorTransferencias?.includes("Possui")
              ? true
              : false,
          saidaTransferencia: tempObj?.saidaTransferencia?.includes("Possui")
            ? true
            : false,
          maioresDezoito: tempObj?.maioresDezoito?.includes("Possui")
            ? true
            : false,
          dataInicio: tempObj?.dataInicio
            ? formatDateToISOWithNow(tempObj?.dataInicio)
            : "",
          dataFim: tempObj?.dataFim
            ? formatDateToISOWithNow(tempObj?.dataFim)
            : "",
          idJustificativas: idsJustificativas,
          idTipoTransferencia: tempObj?.idTipoTransferencia?.id
            ? tempObj?.idTipoTransferencia?.id
            : null,
        },

        localizacaoServicoAcolhimento: {
          estados: tempObj?.idEstado
            ? tempObj?.idEstado
                .flat()
                .map((item) => item.id)
                .filter((item) => item.id !== "")
            : [],
          municipios: tempObj?.idMunicipio
            ? tempObj?.idMunicipio
                .flat()
                .map((item) => ({
                  id: item.id,
                  idEstado: item.idEstado,
                }))
                .filter((item) => item.id !== "")
            : [],
          bairros: tempObj?.idBairro
            ? tempObj?.idBairro
                .flat()
                .map((item) => ({
                  id: item.id,
                  idMunicipio: item.idMunicipio,
                }))
                .filter((item) => item.id !== "")
            : [],
          nomeServicosAcolhimentos: nomeServicosAcolhimentos,
        },

        orgaos: cleanObject({
          municipios: municipiosOrgaos,
          promotorias: promotoriasOrgaos,
          varasInfancias: varasOrgaos,
          orgaoConstaFichaCriancaAdoslecente:
            tempObj?.radioCriterioAtribuicaoCompetencia === "C" ? true : "",
          orgaoConstaFichaServicoAcolhimento:
            tempObj?.radioCriterioAtribuicaoCompetencia === "S" ? true : "",
          mesmoOrgaoFichaCriancaAdoslecenteEFichaServicoAcolhimento:
            tempObj?.radioCriterioAtribuicaoCompetencia === "CS" ? true : "",
        }),

        dadosBasicos: cleanObject({
          generos: generos,
          racasCores: racas,
          faixaEtariaDe: idadeMin,
          faixaEtariaAte: idadeMax,
          comNomeSocial: tempObj?.pesquisarFichas?.includes("S") ? true : "",
          comNomeFicticio: tempObj?.pesquisarFichas?.includes("F") ? true : "",
          comDataNascimentoEstimada: tempObj?.pesquisarFichas?.includes("N")
            ? true
            : "",
        }),
        referenciaFamiliarComunitaria: cleanObject({
          tiposReferencia: idTipoRef,
          nomeReferencia: tempObj?.nomeReferencia,
          irmaosMesmoServico: tempObj?.detalhamentoIrmaos?.includes("A")
            ? true
            : "",
          irmaosServicosDiferentes: tempObj?.detalhamentoIrmaos?.includes("AD")
            ? true
            : "",
          irmaosSemHistoricoAcolhimento: tempObj?.detalhamentoIrmaos?.includes(
            "H",
          )
            ? true
            : "",
          irmaosDesligados: tempObj?.detalhamentoIrmaos?.includes("D")
            ? true
            : "",
        }),
        saude: cleanObject({
          possuiDeficiencia: parseBoolean(tempObj?.radioDeficiencia),
          tiposDeficiencia: idsDeficiencias,
          possuiProblemaSaude: parseBoolean(tempObj?.radioProblemaSaude),
          tiposDoenca: idsDoencas,
          cartaoVacinacao:
            tempObj?.radioCartaoVacinacao.length > 0
              ? tempObj?.radioCartaoVacinacao
              : [],
          usaMedicacaoContinua: parseBoolean(tempObj?.radioMedicacaoContinua),
        }),
        educacao: cleanObject({
          frequentaEscola: parseBoolean(tempObj?.radioFrequentaEscola),
          educacaoEspecial: parseBoolean(tempObj?.radioEducacaoEspecial),
          escolaridadeRepetida: parseBoolean(
            tempObj?.radioEscolaridadeRepetida,
          ),
        }),
        profissionalizacao: cleanObject({
          possuiCursoProfissionalizante: parseBoolean(
            tempObj?.radioPossuiCurso,
          ),
          trabalhaAtualmente: parseBoolean(tempObj?.radioTrabalhaAtualmente),
          fazEstagio: parseBoolean(tempObj?.radioFazEstagio),
          matriculadoJovemAprendiz: parseBoolean(tempObj?.radioJovemAprendiz),
          possuiCurriculoVitae: parseBoolean(tempObj?.radioCurriculoVitae),
        }),

        ...(tempObj?.radioRecebeVisita &&
          typeof tempObj?.radioRecebeVisita === "string" && {
            visita: cleanObject({
              recebeVisita: parseBoolean(tempObj?.radioRecebeVisita),
              faixaPeriodo:
                tempObj?.faixaPeriodo?.id === 1
                  ? "NO_MES"
                  : tempObj?.faixaPeriodo?.id === 2
                    ? "ULTIMOS_3_MESES"
                    : tempObj?.faixaPeriodo?.id === 3
                      ? "ULTIMOS_6_MESES"
                      : tempObj?.faixaPeriodo?.id === 4
                        ? "EM_QUALQUER_PERIODO"
                        : "EM_QUALQUER_PERIODO",
            }),
          }),

        situacaoJuridica: cleanObject({
          possuiProcessoJudicial: parseBoolean(
            tempObj?.radioPossuiProcessoJudicial,
          ),
          tiposProcesso: idsProcesso,
          possuiProcedimentoJudicial: parseBoolean(
            tempObj?.radioPossuiProcedimentoJudicial,
          ),
          tiposProcedimento: idsProcedimento,
          haDecisaoLiminarFamiliaSubstituta: parseBoolean(
            tempObj?.radioDecisaoLiminar,
          ),
          possuiSentenca: parseBoolean(tempObj?.radioSentenca),
          tiposSentenca: idsTipoSentenca,
          recurso:
            tempObj?.radioRecurso === "S"
              ? "S"
              : tempObj?.radioRecurso === "N"
                ? "N"
                : tempObj?.radioRecurso === "I"
                  ? "I"
                  : "",
          transitoEmJulgado: parseBoolean(tempObj?.radioTransitoJulgado),
        }),
        situacaoAdocao: {
          cumpreRequisitosAdocao: parseBoolean(tempObj?.radioCumpreRequisito),
        },

        ...(tempObj?.radioIncluidoPrograma &&
          typeof tempObj?.radioIncluidoPrograma === "string" && {
            programaApadrinhamento: cleanObject({
              incluidoProgramaApadrinhamento:
                tempObj?.radioIncluidoPrograma === "S"
                  ? "SIM"
                  : tempObj?.radioIncluidoPrograma === "N"
                    ? "NAO"
                    : tempObj?.radioIncluidoPrograma === "SI"
                      ? "SEM_INFORMACAO"
                      : "",
              sendoApadrinhado:
                tempObj?.radioSendoApadrinhado === "S"
                  ? "SIM"
                  : tempObj?.radioSendoApadrinhado === "N"
                    ? "NAO"
                    : tempObj?.radioSendoApadrinhado === "SI"
                      ? "SEM_INFORMACAO"
                      : "",
            }),
          }),
        pageSize: tempObj?.pageSize,
        page: pagina,
        ...(tempObj?.desc !== undefined
          ? {
              sortField: tempObj.sort,
              sortType: tempObj.desc ? "DESC" : "ASC",
            }
          : {}),
      };

      let pesquisarFn = RelatorioService.getRelatorioCriancaGeral;

      pesquisarFn(storageValues).then((res) => {
        sessionStorage.setItem(
          entidade + "-filter",
          JSON.stringify({
            ...tempObj,
            totalItems: res.data.totalElements,
            totalPages: res.data.totalPages,
          }),
        );

        setData(res.data);
        setLoading(false);
      });
    } else if (entidade === "relatorio-servico-acolhimento") {
      setLoading(true);
      let tempObj = JSON.parse(sessionStorage.getItem(entidade + "-filter"));
      tempObj.page = pagina;
      sessionStorage.setItem(entidade + "-filter", JSON.stringify(tempObj));

      const statusMap = {
        A: "ATIVO",
        D: "DESATIVADO",
        S: "SUSPENSO",
      };
      const status = tempObj?.statusRelatorio.map((item) => statusMap[item]);
      const generos = (tempObj?.idGenero || [])
        ?.flat()
        ?.map((item) => item.genero)
        ?.filter(Boolean);
      const nomeServicosAcolhimentos = (tempObj?.idsServicosAcolhimento || [])
        ?.flat()
        ?.map((item) => item.nomeFantasia)
        ?.filter(Boolean);
      const municipiosOrgaos = (tempObj?.idMunicipioOrgao || [])
        ?.flat()
        ?.map((item) => item.id)
        ?.filter((id) => id !== "" && id != null);
      const promotoriasOrgaos = (tempObj?.idPromotoriaOrgaos || [])
        ?.flat()
        ?.map((item) => ({
          id: item.id,
          idMunicipio: item.idMunicipio,
        }))
        ?.filter((id) => id !== "" && id != null);
      const varasOrgaos = (tempObj?.idVaraOrgaos || [])
        ?.flat()
        ?.map((item) => ({
          id: item.id,
          idMunicipio: item.idMunicipio,
        }))
        ?.filter((id) => id !== "" && id != null);
      const naturezas = (tempObj?.naturezaServico || [])
        ?.flat()
        ?.map((item) => item?.id?.toUpperCase())
        ?.filter((id) => id !== "" && id != null);
      const regimes = (tempObj?.regime || [])
        ?.flat()
        ?.map((item) => item.id)
        ?.filter((id) => id !== "" && id != null);
      const modalidades = (tempObj?.modalidade || [])
        ?.flat()
        ?.map((item) => item.descricao)
        ?.filter(Boolean);
      const SAF =
        Array.isArray(tempObj?.regime) &&
        tempObj?.regime?.flat()?.some((item) => item.id === "SAF");

      const idadeMin = [tempObj?.idadeInicial, tempObj?.idadeMinima].find(
        (v) => v != null && v !== "" && v !== "null",
      );

      const idadeMax = [tempObj?.idadeFinal, tempObj?.idadeMaxima].find(
        (v) => v != null && v !== "" && v !== "null",
      );
      const storageValues = {
        status: status,
        localizacaoServicoAcolhimento: {
          estados: tempObj?.idEstado
            ? tempObj?.idEstado
                .flat()
                .map((item) => item.id)
                .filter((item) => item.id !== "")
            : [],
          municipios: tempObj?.idMunicipio
            ? tempObj?.idMunicipio
                .flat()
                .map((item) => ({
                  id: item.id,
                  idEstado: item.idEstado,
                }))
                .filter((item) => item.id !== "")
            : [],
          bairros: tempObj?.idBairro
            ? tempObj?.idBairro
                .flat()
                .map((item) => ({
                  id: item.id,
                  idMunicipio: item.idMunicipio,
                }))
                .filter((item) => item.id !== "")
            : [],
          nomeServicosAcolhimentos: nomeServicosAcolhimentos,
        },
        orgaos: {
          municipios: municipiosOrgaos,
          promotorias: promotoriasOrgaos,
          varasInfancias: varasOrgaos,
        },
        caracterizacaoServicoAcolhimento: {
          regimes: regimes,
          modalidades:
            SAF &&
            !modalidades.includes("Não se aplica") &&
            modalidades?.length > 0
              ? [...modalidades, "Não se aplica"]
              : modalidades,
          naturezas: naturezas,
        },
        perfilAtendimento: {
          ...(tempObj?.radioGenero && {
            tipoGenero:
              tempObj.radioGenero === "AS"
                ? "ATENDE"
                : tempObj.radioGenero === "SR"
                  ? "SEM_RESTRICAO"
                  : tempObj.radioGenero === "NA"
                    ? "NAO_ATENDE"
                    : "",
          }),

          generos: generos.length > 0 ? generos : [],

          ...(tempObj?.radioFaixaEtaria && {
            restricao:
              tempObj.radioFaixaEtaria === "TO"
                ? "TODOS"
                : tempObj.radioFaixaEtaria === "AT"
                  ? "ATENDE"
                  : tempObj.radioFaixaEtaria === "CR"
                    ? "COM_RESTRICAO"
                    : "",
          }),

          ...(idadeMin && {
            idadeMinima: Number(idadeMin),
          }),

          ...(idadeMax && {
            idadeMaxima: Number(idadeMax),
          }),

          restricaoDeficiencia:
            tempObj?.radioSaudeCriancaDeficiencia?.length > 0
              ? tempObj?.radioSaudeCriancaDeficiencia
              : [],

          restricaoSubstancias:
            tempObj?.radioSaudeSubstanciasPsicoativas?.length > 0
              ? tempObj?.radioSaudeSubstanciasPsicoativas
              : [],

          restricaoCuidados:
            tempObj?.radioSaudeCriancaCuidados?.length > 0
              ? tempObj?.radioSaudeCriancaCuidados
              : [],
        },

        regularidade: {
          registroCMDCA: tempObj?.registroCMDCA ? tempObj?.registroCMDCA : [],
          registroValidoCMDCA: tempObj?.registroValidoCMDCA
            ? tempObj?.registroValidoCMDCA
            : [],
          inscricaoCMDCA: tempObj?.inscricaoCMDCA
            ? tempObj?.inscricaoCMDCA
            : [],
          inscricaoValidaCMDCA: tempObj?.inscricaoValidaCMDCA
            ? tempObj?.inscricaoValidaCMDCA
            : [],
          inscricaoCMAS: tempObj?.inscricaoCMAS ? tempObj?.inscricaoCMAS : [],
          inscricaoValidaCMAS: tempObj?.inscricaoValidaCMAS
            ? tempObj?.inscricaoValidaCMAS
            : [],
        },

        planejamento: {
          possuiPlanoTrabalho: tempObj?.possuiPlano ? tempObj?.possuiPlano : [],
          possuiProjetoPoliticoPedagogico: tempObj?.possuiProjeto
            ? tempObj?.possuiProjeto
            : [],
          possuiRelatorioAnual: tempObj?.possuiRelatorio
            ? tempObj?.possuiRelatorio
            : [],
          possuiRegimentoInterno: tempObj?.possuiRegimento
            ? tempObj?.possuiRegimento
            : [],
        },

        possuiAcessoMCA: tempObj?.possuiAcessoMCA
          ? tempObj?.possuiAcessoMCA
          : [],
        possuiVoluntariado: tempObj?.possuiVoluntariado
          ? tempObj?.possuiVoluntariado
          : [],

        apadrinhamento: {
          mantemProgramaApadrinhamento: tempObj?.mantemPrograma
            ? tempObj?.mantemPrograma
            : [],
          inscritoCMDCA: tempObj?.encontraInscritoCMDCA
            ? tempObj?.encontraInscritoCMDCA
            : [],
        },

        ...((tempObj?.possuiVaga === "S" || tempObj?.possuiVaga === "N") && {
          vagasDisponiveis: tempObj?.possuiVaga === "S",
        }),
        pageSize: tempObj?.pageSize,
        page: pagina,
        ...(tempObj?.desc !== undefined
          ? {
              sortField: tempObj.sort,
              sortType: tempObj.desc ? "DESC" : "ASC",
            }
          : {}),
      };

      let pesquisarFn = RelatorioService.getRelatorioServicoAcolhimento;

      pesquisarFn(storageValues).then((res) => {
        sessionStorage.setItem(
          entidade + "-filter",
          JSON.stringify({
            ...tempObj,
            totalItems: res.data.totalElements,
            totalPages: res.data.totalPages,
          }),
        );

        setData(res.data);
        setLoading(false);
      });
    } else {
      sessionStorage.setItem(entidade + "-pagination-page", pagina);
    }
    gotoPage(pagina);
  }

  function selecionarTotalItens(nItens) {
    sessionStorage.setItem(entidade + "-pagination-count", nItens);

    if (entidade === "relatorio-pendencia") {
      setLoading(true);
      let tempObj = JSON.parse(sessionStorage.getItem(entidade + "-filter"));
      tempObj.page = 0;
      tempObj.pageSize = nItens;

      const storageValues = {
        municipioId: tempObj?.municipioId ? tempObj.municipioId.id : "",
        promocaoId: tempObj?.promocaoId ? tempObj.promocaoId.id : "",
        tipoRelatorio: tempObj?.tipoRelatorio
          ? tempObj.tipoRelatorio.value
          : "",
        servicoAtendimentoId: tempObj?.servicoAtendimentoId
          ? tempObj.servicoAtendimentoId.id
          : "",
        dataReferencia: tempObj?.dataReferencia
          ? formatDateToISOWithNow(tempObj.dataReferencia)
          : "",
        pageSize: nItens,
        page: tempObj?.page,
        ...(tempObj?.desc !== undefined
          ? {
              sortField: tempObj.sort,
              sortType: tempObj.desc ? "DESC" : "ASC",
            }
          : {}),
      };

      let pesquisarFn =
        storageValues.tipoRelatorio ===
        "RELATORIO_PENDENCIAS_SERVICOS_ACOLHIMENTO"
          ? RelatorioService.getRelatorioPendenciaServico
          : RelatorioService.getRelatorioPendenciaCrianca;

      pesquisarFn(token, storageValues).then((res) => {
        sessionStorage.setItem(
          entidade + "-filter",
          JSON.stringify({
            ...tempObj,
            totalItems: res.data.totalElements,
            totalPages: res.data.totalPages,
          }),
        );

        setData(res.data);
        setLoading(false);
      });
    } else if (entidade === "fila-processamento") {
      setLoading(true);
      let tempObj = JSON.parse(sessionStorage.getItem(entidade + "-filter"));
      tempObj.page = 0;
      tempObj.pageSize = nItens;

      const storageValues = {
        nomeResponsavel: tempObj?.nomeResponsavel
          ? tempObj.nomeResponsavel
          : "",
        statusRelatorio: tempObj?.statusRelatorio
          ? tempObj.statusRelatorio
          : "",
        tipoRelatorio: tempObj?.tipoRelatorio ? tempObj.tipoRelatorio : "",
        pageSize: nItens,
        page: tempObj?.page,
        ...(tempObj?.sortType !== undefined
          ? {
              sortType: tempObj.sortType ?? "DESC",
            }
          : {}),
      };

      RelatorioService.getFilaProcessamento(token, storageValues).then(
        (res) => {
          sessionStorage.setItem(
            entidade + "-filter",
            JSON.stringify({
              ...tempObj,
              totalItems: res.data.totalElements,
              totalPages: res.data.totalPages,
            }),
          );

          setData(res.data);
          setLoading(false);
        },
      );
    } else if (entidade === "relatorio-crianca-adolescente") {
      setLoading(true);
      let tempObj = JSON.parse(sessionStorage.getItem(entidade + "-filter"));
      tempObj.page = 0;
      tempObj.pageSize = nItens;

      const idsServicoAcolhimentoChange = props.roleKeycloack.includes(
        criancaFunc.visualizarTudoAcolhimento,
      )
        ? [tempObj?.idsServicosAcolhimento.value]
        : Array.isArray(tempObj?.idsServicosAcolhimento)
          ? tempObj.idsServicosAcolhimento
              .flat()
              .map((item) => item.value)
              .filter((value) => value !== "")
          : [];

      const storageValues = {
        universoConsulta: tempObj?.universoConsulta
          ? tempObj.universoConsulta.label
              ?.toUpperCase()
              ?.normalize("NFD")
              ?.replace(/[\u0300-\u036f]/g, "")
              ?.toUpperCase()
          : "",
        idsServicosAcolhimento: tempObj?.idsServicosAcolhimento
          ? idsServicoAcolhimentoChange
          : [],
        dataInicio: tempObj?.dataInicio ? formatarData(tempObj.dataInicio) : "",
        dataFim: tempObj?.dataFim ? formatarData(tempObj.dataFim) : "",
        idsMotivosEntrada: tempObj?.idsMotivosEntrada
          ? tempObj.idsMotivosEntrada
              .flat()
              .map((item) => item.id)
              .filter((id) => id !== "")
          : "",
        idTipoTransferencia: tempObj?.idTipoTransferencia
          ? tempObj.idTipoTransferencia.id
          : "",
        idJustificativas: tempObj?.idJustificativas
          ? tempObj?.idJustificativas
              .flat()
              .map((item) => item.id)
              .filter((id) => id !== "")
          : "",

        tipoPeriodo: tempObj?.tipoPeriodo === "A" ? "SITUACAO_ATUAL" : "DATA",
        entradasPorTransferencias:
          Array.isArray(tempObj?.entradasPorTransferencias) &&
          tempObj.entradasPorTransferencias.includes("Possui"),

        maioresDezoito:
          Array.isArray(tempObj?.maioresDezoito) &&
          tempObj.maioresDezoito.includes("Possui"),
        saidaTransferencia:
          Array.isArray(tempObj?.saidaTransferencia) &&
          tempObj.saidaTransferencia.includes("Possui"),
        pageSize: nItens,
        page: tempObj?.page,
        ...(tempObj?.desc !== undefined
          ? {
              sortField: tempObj.sort,
              sortType: tempObj.desc ? "DESC" : "ASC",
            }
          : {}),
      };

      let pesquisarFn = RelatorioService.getRelatorioCrianca;

      pesquisarFn(token, storageValues).then((res) => {
        sessionStorage.setItem(
          entidade + "-filter",
          JSON.stringify({
            ...tempObj,
            totalItems: res.data.totalElements,
            totalPages: res.data.totalPages,
          }),
        );

        setData(res.data);
        setLoading(false);
      });
    } else if (entidade === "relatorio-crianca-adolescente-geral") {
      setLoading(true);
      let tempObj = JSON.parse(sessionStorage.getItem(entidade + "-filter"));
      tempObj.page = 0;
      tempObj.pageSize = nItens;

      const idsProcesso = (tempObj?.idProcesso || [])
        ?.flat()
        ?.map((item) => item.id)
        ?.filter(Boolean);
      const idsTipoSentenca = (tempObj?.idTipoSentenca || [])
        ?.flat()
        ?.map((item) => item.id)
        ?.filter(Boolean);
      const idsProcedimento = (tempObj?.idProcedimento || [])
        ?.flat()
        ?.map((item) => item.id)
        ?.filter(Boolean);

      const idsDeficiencias = tempObj?.deficiencias
        ? (() => {
            const flat = tempObj?.deficiencias.flat();

            const hasTodos = flat.some((item) => item.id === "");

            if (hasTodos) return [0];

            return flat
              .map((item) => item.idTipoDeficiencia ?? item.value)
              .filter((id) => id !== null && id !== undefined && id !== "");
          })()
        : [];

      const idsDoencas = tempObj?.doencas
        ? (() => {
            const flat = tempObj?.doencas.flat();

            const hasTodos = flat.some((item) => item.id === "");

            if (hasTodos) return [0];

            return flat
              .map((item) => item.idDoenca ?? item.value)
              .filter((id) => id !== null && id !== undefined && id !== "");
          })()
        : [];

      const generos = (tempObj?.idGenero || [])
        ?.flat()
        ?.map((item) => item.id)
        ?.filter(Boolean);

      const racas = (tempObj?.idRaca || [])
        ?.flat()
        ?.map((item) => item.id)
        ?.filter(Boolean);

      const idTipoRef = tempObj?.idTipoReferencia
        ? (() => {
            const flat = tempObj?.idTipoReferencia.flat();

            const hasTodos = flat.some((item) => item.id === "");

            if (hasTodos) return [0];

            return flat
              .map((item) => item.id ?? item.value)
              .filter((id) => id !== null && id !== undefined && id !== "");
          })()
        : [];

      const nomeServicosAcolhimentos = (tempObj?.idsServicosAcolhimento || [])
        ?.flat()
        ?.map((item) => item.nomeFantasia)
        ?.filter(Boolean);

      const idsJustificativas = (tempObj?.idJustificativas || [])
        ?.flat()
        ?.map((item) => item.id)
        ?.filter(Boolean);

      const idsMotivo = (tempObj?.idsMotivosEntrada || [])
        ?.flat()
        ?.map((item) => item.id)
        ?.filter(Boolean);
      const idsServicos = (tempObj?.idsServicosAcolhimento || [])
        ?.flat()
        ?.map((item) => item.id)
        ?.filter(Boolean);
      const municipiosOrgaos = (tempObj?.idMunicipioOrgao || [])
        ?.flat()
        ?.map((item) => item.id)
        ?.filter((id) => id !== "" && id != null);
      const promotoriasOrgaos = (tempObj?.idPromotoriaOrgaos || [])
        ?.flat()
        ?.map((item) => ({
          id: item.id,
          idMunicipio: item.idMunicipio,
        }))
        ?.filter((id) => id !== "" && id != null);
      const varasOrgaos = (tempObj?.idVaraOrgaos || [])
        ?.flat()
        ?.map((item) => ({
          id: item.id,
          idMunicipio: item.idMunicipio,
        }))
        ?.filter((id) => id !== "" && id != null);

      const idadeMin = [tempObj?.idadeInicial].find(
        (v) => v != null && v !== "" && v !== "null",
      );

      const idadeMax = [tempObj?.idadeFinal].find(
        (v) => v != null && v !== "" && v !== "null",
      );

      const storageValues = {
        universoConsulta: {
          universo:
            tempObj?.universoConsulta === 1
              ? "ACOLHIDO"
              : tempObj?.universoConsulta === 2
                ? "DESLIGADO"
                : tempObj?.universoConsulta === 3
                  ? "TRANSFERENCIA"
                  : "PENDENTE",
          idsServicosAcolhimento: idsServicos,
          idsMotivosEntrada: idsMotivo,
          tipoPeriodo:
            tempObj?.tipoPeriodo === "A"
              ? "SITUACAO_ATUAL"
              : tempObj?.tipoPeriodo === "D"
                ? "DATA"
                : "",

          entradasPorTransferencias:
            tempObj?.entradasPorTransferencias?.includes("Possui")
              ? true
              : false,
          saidaTransferencia: tempObj?.saidaTransferencia?.includes("Possui")
            ? true
            : false,
          maioresDezoito: tempObj?.maioresDezoito?.includes("Possui")
            ? true
            : false,
          dataInicio: tempObj?.dataInicio
            ? formatDateToISOWithNow(tempObj?.dataInicio)
            : "",
          dataFim: tempObj?.dataFim
            ? formatDateToISOWithNow(tempObj?.dataFim)
            : "",
          idJustificativas: idsJustificativas,
          idTipoTransferencia: tempObj?.idTipoTransferencia?.id
            ? tempObj?.idTipoTransferencia?.id
            : null,
        },

        localizacaoServicoAcolhimento: {
          estados: tempObj?.idEstado
            ? tempObj?.idEstado
                .flat()
                .map((item) => item.id)
                .filter((item) => item.id !== "")
            : [],
          municipios: tempObj?.idMunicipio
            ? tempObj?.idMunicipio
                .flat()
                .map((item) => ({
                  id: item.id,
                  idEstado: item.idEstado,
                }))
                .filter((item) => item.id !== "")
            : [],
          bairros: tempObj?.idBairro
            ? tempObj?.idBairro
                .flat()
                .map((item) => ({
                  id: item.id,
                  idMunicipio: item.idMunicipio,
                }))
                .filter((item) => item.id !== "")
            : [],
          nomeServicosAcolhimentos: nomeServicosAcolhimentos,
        },

        orgaos: cleanObject({
          municipios: municipiosOrgaos,
          promotorias: promotoriasOrgaos,
          varasInfancias: varasOrgaos,
          orgaoConstaFichaCriancaAdoslecente:
            tempObj?.radioCriterioAtribuicaoCompetencia === "C" ? true : "",
          orgaoConstaFichaServicoAcolhimento:
            tempObj?.radioCriterioAtribuicaoCompetencia === "S" ? true : "",
          mesmoOrgaoFichaCriancaAdoslecenteEFichaServicoAcolhimento:
            tempObj?.radioCriterioAtribuicaoCompetencia === "CS" ? true : "",
        }),

        dadosBasicos: cleanObject({
          generos: generos,
          racasCores: racas,
          faixaEtariaDe: idadeMin,
          faixaEtariaAte: idadeMax,
          comNomeSocial: tempObj?.pesquisarFichas?.includes("S") ? true : "",
          comNomeFicticio: tempObj?.pesquisarFichas?.includes("F") ? true : "",
          comDataNascimentoEstimada: tempObj?.pesquisarFichas?.includes("N")
            ? true
            : "",
        }),
        referenciaFamiliarComunitaria: cleanObject({
          tiposReferencia: idTipoRef,
          nomeReferencia: tempObj?.nomeReferencia,
          irmaosMesmoServico: tempObj?.detalhamentoIrmaos?.includes("A")
            ? true
            : "",
          irmaosServicosDiferentes: tempObj?.detalhamentoIrmaos?.includes("AD")
            ? true
            : "",
          irmaosSemHistoricoAcolhimento: tempObj?.detalhamentoIrmaos?.includes(
            "H",
          )
            ? true
            : "",
          irmaosDesligados: tempObj?.detalhamentoIrmaos?.includes("D")
            ? true
            : "",
        }),
        saude: cleanObject({
          possuiDeficiencia: parseBoolean(tempObj?.radioDeficiencia),
          tiposDeficiencia: idsDeficiencias,
          possuiProblemaSaude: parseBoolean(tempObj?.radioProblemaSaude),
          tiposDoenca: idsDoencas,
          cartaoVacinacao:
            tempObj?.radioCartaoVacinacao.length > 0
              ? tempObj?.radioCartaoVacinacao
              : [],
          usaMedicacaoContinua: parseBoolean(tempObj?.radioMedicacaoContinua),
        }),
        educacao: cleanObject({
          frequentaEscola: parseBoolean(tempObj?.radioFrequentaEscola),
          educacaoEspecial: parseBoolean(tempObj?.radioEducacaoEspecial),
          escolaridadeRepetida: parseBoolean(
            tempObj?.radioEscolaridadeRepetida,
          ),
        }),
        profissionalizacao: cleanObject({
          possuiCursoProfissionalizante: parseBoolean(
            tempObj?.radioPossuiCurso,
          ),
          trabalhaAtualmente: parseBoolean(tempObj?.radioTrabalhaAtualmente),
          fazEstagio: parseBoolean(tempObj?.radioFazEstagio),
          matriculadoJovemAprendiz: parseBoolean(tempObj?.radioJovemAprendiz),
          possuiCurriculoVitae: parseBoolean(tempObj?.radioCurriculoVitae),
        }),

        ...(tempObj?.radioRecebeVisita &&
          typeof tempObj?.radioRecebeVisita === "string" && {
            visita: cleanObject({
              recebeVisita: parseBoolean(tempObj?.radioRecebeVisita),
              faixaPeriodo:
                tempObj?.faixaPeriodo?.id === 1
                  ? "NO_MES"
                  : tempObj?.faixaPeriodo?.id === 2
                    ? "ULTIMOS_3_MESES"
                    : tempObj?.faixaPeriodo?.id === 3
                      ? "ULTIMOS_6_MESES"
                      : tempObj?.faixaPeriodo?.id === 4
                        ? "EM_QUALQUER_PERIODO"
                        : "EM_QUALQUER_PERIODO",
            }),
          }),

        situacaoJuridica: cleanObject({
          possuiProcessoJudicial: parseBoolean(
            tempObj?.radioPossuiProcessoJudicial,
          ),
          tiposProcesso: idsProcesso,
          possuiProcedimentoJudicial: parseBoolean(
            tempObj?.radioPossuiProcedimentoJudicial,
          ),
          tiposProcedimento: idsProcedimento,
          haDecisaoLiminarFamiliaSubstituta: parseBoolean(
            tempObj?.radioDecisaoLiminar,
          ),
          possuiSentenca: parseBoolean(tempObj?.radioSentenca),
          tiposSentenca: idsTipoSentenca,
          recurso:
            tempObj?.radioRecurso === "S"
              ? "S"
              : tempObj?.radioRecurso === "N"
                ? "N"
                : tempObj?.radioRecurso === "I"
                  ? "I"
                  : "",
          transitoEmJulgado: parseBoolean(tempObj?.radioTransitoJulgado),
        }),
        situacaoAdocao: {
          cumpreRequisitosAdocao: parseBoolean(tempObj?.radioCumpreRequisito),
        },

        ...(tempObj?.radioIncluidoPrograma &&
          typeof tempObj?.radioIncluidoPrograma === "string" && {
            programaApadrinhamento: cleanObject({
              incluidoProgramaApadrinhamento:
                tempObj?.radioIncluidoPrograma === "S"
                  ? "SIM"
                  : tempObj?.radioIncluidoPrograma === "N"
                    ? "NAO"
                    : tempObj?.radioIncluidoPrograma === "SI"
                      ? "SEM_INFORMACAO"
                      : "",
              sendoApadrinhado:
                tempObj?.radioSendoApadrinhado === "S"
                  ? "SIM"
                  : tempObj?.radioSendoApadrinhado === "N"
                    ? "NAO"
                    : tempObj?.radioSendoApadrinhado === "SI"
                      ? "SEM_INFORMACAO"
                      : "",
            }),
          }),

        pageSize: nItens,
        page: tempObj?.page,
        ...(tempObj?.desc !== undefined
          ? {
              sortField: tempObj.sort,
              sortType: tempObj.desc ? "DESC" : "ASC",
            }
          : {}),
      };

      let pesquisarFn = RelatorioService.getRelatorioCriancaGeral;

      pesquisarFn(storageValues).then((res) => {
        sessionStorage.setItem(
          entidade + "-filter",
          JSON.stringify({
            ...tempObj,
            totalItems: res.data.totalElements,
            totalPages: res.data.totalPages,
          }),
        );

        setData(res.data);
        setLoading(false);
      });
    } else if (entidade === "relatorio-servico-acolhimento") {
      setLoading(true);
      let tempObj = JSON.parse(sessionStorage.getItem(entidade + "-filter"));
      tempObj.page = 0;
      tempObj.pageSize = nItens;

      const statusMap = {
        A: "ATIVO",
        D: "DESATIVADO",
        S: "SUSPENSO",
      };
      const status = tempObj?.statusRelatorio.map((item) => statusMap[item]);
      const generos = (tempObj?.idGenero || [])
        ?.flat()
        ?.map((item) => item.genero)
        ?.filter(Boolean);
      const nomeServicosAcolhimentos = (tempObj?.idsServicosAcolhimento || [])
        ?.flat()
        ?.map((item) => item.nomeFantasia)
        ?.filter(Boolean);
      const municipiosOrgaos = (tempObj?.idMunicipioOrgao || [])
        ?.flat()
        ?.map((item) => item.id)
        ?.filter((id) => id !== "" && id != null);
      const promotoriasOrgaos = (tempObj?.idPromotoriaOrgaos || [])
        ?.flat()
        ?.map((item) => ({
          id: item.id,
          idMunicipio: item.idMunicipio,
        }))
        ?.filter((id) => id !== "" && id != null);
      const varasOrgaos = (tempObj?.idVaraOrgaos || [])
        ?.flat()
        ?.map((item) => ({
          id: item.id,
          idMunicipio: item.idMunicipio,
        }))
        ?.filter((id) => id !== "" && id != null);
      const naturezas = (tempObj?.naturezaServico || [])
        ?.flat()
        ?.map((item) => item?.id?.toUpperCase())
        ?.filter((id) => id !== "" && id != null);
      const regimes = (tempObj?.regime || [])
        ?.flat()
        ?.map((item) => item.id)
        ?.filter((id) => id !== "" && id != null);
      const modalidades = (tempObj?.modalidade || [])
        ?.flat()
        ?.map((item) => item.descricao)
        ?.filter(Boolean);
      const SAF =
        Array.isArray(tempObj?.regime) &&
        tempObj?.regime?.flat()?.some((item) => item.id === "SAF");

      const idadeMin = [tempObj?.idadeInicial, tempObj?.idadeMinima].find(
        (v) => v != null && v !== "" && v !== "null",
      );

      const idadeMax = [tempObj?.idadeFinal, tempObj?.idadeMaxima].find(
        (v) => v != null && v !== "" && v !== "null",
      );

      const storageValues = {
        status: status,
        localizacaoServicoAcolhimento: {
          estados: tempObj?.idEstado
            ? tempObj?.idEstado
                .flat()
                .map((item) => item.id)
                .filter((item) => item.id !== "")
            : [],
          municipios: tempObj?.idMunicipio
            ? tempObj?.idMunicipio
                .flat()
                .map((item) => ({
                  id: item.id,
                  idEstado: item.idEstado,
                }))
                .filter((item) => item.id !== "")
            : [],
          bairros: tempObj?.idBairro
            ? tempObj?.idBairro
                .flat()
                .map((item) => ({
                  id: item.id,
                  idMunicipio: item.idMunicipio,
                }))
                .filter((item) => item.id !== "")
            : [],
          nomeServicosAcolhimentos: nomeServicosAcolhimentos,
        },
        orgaos: {
          municipios: municipiosOrgaos,
          promotorias: promotoriasOrgaos,
          varasInfancias: varasOrgaos,
        },
        caracterizacaoServicoAcolhimento: {
          regimes: regimes,
          modalidades:
            SAF &&
            !modalidades.includes("Não se aplica") &&
            modalidades?.length > 0
              ? [...modalidades, "Não se aplica"]
              : modalidades,
          naturezas: naturezas,
        },
        perfilAtendimento: {
          ...(tempObj?.radioGenero && {
            tipoGenero:
              tempObj.radioGenero === "AS"
                ? "ATENDE"
                : tempObj.radioGenero === "SR"
                  ? "SEM_RESTRICAO"
                  : tempObj.radioGenero === "NA"
                    ? "NAO_ATENDE"
                    : "",
          }),

          generos: generos.length > 0 ? generos : [],

          ...(tempObj?.radioFaixaEtaria && {
            restricao:
              tempObj.radioFaixaEtaria === "TO"
                ? "TODOS"
                : tempObj.radioFaixaEtaria === "AT"
                  ? "ATENDE"
                  : tempObj.radioFaixaEtaria === "CR"
                    ? "COM_RESTRICAO"
                    : "",
          }),

          ...(idadeMin && {
            idadeMinima: Number(idadeMin),
          }),

          ...(idadeMax && {
            idadeMaxima: Number(idadeMax),
          }),

          restricaoDeficiencia:
            tempObj?.radioSaudeCriancaDeficiencia?.length > 0
              ? tempObj?.radioSaudeCriancaDeficiencia
              : [],

          restricaoSubstancias:
            tempObj?.radioSaudeSubstanciasPsicoativas?.length > 0
              ? tempObj?.radioSaudeSubstanciasPsicoativas
              : [],

          restricaoCuidados:
            tempObj?.radioSaudeCriancaCuidados?.length > 0
              ? tempObj?.radioSaudeCriancaCuidados
              : [],
        },

        regularidade: {
          registroCMDCA: tempObj?.registroCMDCA ? tempObj?.registroCMDCA : [],
          registroValidoCMDCA: tempObj?.registroValidoCMDCA
            ? tempObj?.registroValidoCMDCA
            : [],
          inscricaoCMDCA: tempObj?.inscricaoCMDCA
            ? tempObj?.inscricaoCMDCA
            : [],
          inscricaoValidaCMDCA: tempObj?.inscricaoValidaCMDCA
            ? tempObj?.inscricaoValidaCMDCA
            : [],
          inscricaoCMAS: tempObj?.inscricaoCMAS ? tempObj?.inscricaoCMAS : [],
          inscricaoValidaCMAS: tempObj?.inscricaoValidaCMAS
            ? tempObj?.inscricaoValidaCMAS
            : [],
        },

        planejamento: {
          possuiPlanoTrabalho: tempObj?.possuiPlano ? tempObj?.possuiPlano : [],
          possuiProjetoPoliticoPedagogico: tempObj?.possuiProjeto
            ? tempObj?.possuiProjeto
            : [],
          possuiRelatorioAnual: tempObj?.possuiRelatorio
            ? tempObj?.possuiRelatorio
            : [],
          possuiRegimentoInterno: tempObj?.possuiRegimento
            ? tempObj?.possuiRegimento
            : [],
        },

        possuiAcessoMCA: tempObj?.possuiAcessoMCA
          ? tempObj?.possuiAcessoMCA
          : [],
        possuiVoluntariado: tempObj?.possuiVoluntariado
          ? tempObj?.possuiVoluntariado
          : [],

        apadrinhamento: {
          mantemProgramaApadrinhamento: tempObj?.mantemPrograma
            ? tempObj?.mantemPrograma
            : [],
          inscritoCMDCA: tempObj?.encontraInscritoCMDCA
            ? tempObj?.encontraInscritoCMDCA
            : [],
        },

        ...((tempObj?.possuiVaga === "S" || tempObj?.possuiVaga === "N") && {
          vagasDisponiveis: tempObj?.possuiVaga === "S",
        }),
        pageSize: nItens,
        page: tempObj?.page,
        ...(tempObj?.desc !== undefined
          ? {
              sortField: tempObj.sort,
              sortType: tempObj.desc ? "DESC" : "ASC",
            }
          : {}),
      };

      let pesquisarFn = RelatorioService.getRelatorioServicoAcolhimento;

      pesquisarFn(storageValues).then((res) => {
        sessionStorage.setItem(
          entidade + "-filter",
          JSON.stringify({
            ...tempObj,
            totalItems: res.data.totalElements,
            totalPages: res.data.totalPages,
          }),
        );

        setData(res.data);
        setLoading(false);
      });
    }
    setPageSize(nItens);
  }

  const handleSortingPersistence = (column) => {
    const hasOrdered = ordered.find((order) => order.id === column.id);
    const tempOrdered = [];

    let sortedDesc =
      column.isSortedDesc === undefined
        ? false
        : column.isSortedDesc === false
          ? true
          : undefined;

    if (!shiftPressed) {
      sessionStorage.removeItem("tabela-cadastros");
    }

    if (shiftPressed) {
      if (hasOrdered) {
        tempOrdered.push(
          ...ordered.map((order) =>
            order.id === column.id
              ? { id: column.id, desc: sortedDesc }
              : order,
          ),
        );
        setOrdered(tempOrdered);
      } else {
        tempOrdered.push(...ordered, { id: column.id, desc: sortedDesc });
        setOrdered(tempOrdered);
      }
    } else {
      tempOrdered.push({ id: column.id, desc: sortedDesc });
      setOrdered(tempOrdered);
    }

    sessionStorage.setItem(`table-${entidade}`, JSON.stringify(tempOrdered));
    selecionarOrdenacao({ id: column.id, desc: sortedDesc });
  };

  return (
    <Flex flexDir="column" w="100%">
      <Flex flexDir="column" width="100%" mt="20px" h="100%">
        <Flex w={"100%"} flexDir={"column"}>
          {isEmptyArray(data) ? (
            <SemRegistros
              loading={loading}
              entidade={entidade}
              buttonVisible={
                entidade === "relatorio-pendencia" ||
                entidade === "fila-processamento" ||
                entidade === "relatorio-crianca-adolescente" ||
                entidade === "relatorio-servico-acolhimento" ||
                entidade === "relatorio-crianca-adolescente-geral"
              }
              half
              crianca={true}
              data={data}
              name={name}
            />
          ) : (
            <>
              <Permission
                roleKeycloack={props.roleKeycloack}
                func={entidade === "visitas" ? visitasFunc.visitaConsultar : ""}
              >
                <Flex flexDir={"column"}>
                  <Flex overflowX="auto" pb={5}>
                    <Table
                      {...getTableProps}
                      backgroundColor="white"
                      sx={
                        entidade === "fila-processamento"
                          ? {
                              borderCollapse: "separate !important",
                              borderSpacing: "0 8px !important",
                            }
                          : {}
                      }
                    >
                      <Thead
                        backgroundColor="#ECEFF1"
                        display={entidade === "fila-processamento" && "none"}
                      >
                        {headerGroups.map((headerGroup, index) => (
                          <Tr
                            {...headerGroup.getHeaderGroupProps()}
                            key={index}
                          >
                            {headerGroup.headers.map((column, index) => (
                              <Th
                                {...column.getHeaderProps(
                                  column.getSortByToggleProps({
                                    title: undefined,
                                  }),
                                )}
                                key={index}
                                p="0px"
                              >
                                <Flex
                                  flexDir="row"
                                  alignContent="center"
                                  px="24px"
                                  py="12px"
                                  onClick={
                                    column.Header !== "Opções"
                                      ? () => {
                                          handleSortingPersistence(column);
                                        }
                                      : null
                                  }
                                >
                                  <Text
                                    as="p"
                                    whiteSpace={{
                                      base:
                                        column.Header ===
                                          "Serviço de Acolhimento Atual" &&
                                        (entidade ===
                                          "relatorio-servico-acolhimento" ||
                                          entidade ===
                                            "relatorio-crianca-adolescente-geral") &&
                                        "nowrap",
                                    }}
                                  >
                                    {column.render("Header")}
                                  </Text>

                                  {column.Header !== "Opções" ? (
                                    <Flex pl={1} alignItems="center">
                                      {column.isSorted ? (
                                        column.isSortedDesc ? (
                                          <Icon
                                            as={FaSortDown}
                                            boxSize="14px"
                                          />
                                        ) : (
                                          <Icon as={FaSortUp} boxSize="14px" />
                                        )
                                      ) : (
                                        <Icon as={FaSort} boxSize="14px" />
                                      )}
                                    </Flex>
                                  ) : (
                                    ""
                                  )}
                                </Flex>
                              </Th>
                            ))}
                          </Tr>
                        ))}
                      </Thead>
                      {loading ? (
                        <Tbody>
                          <Tr>
                            <Td colSpan={5} textAlign="center">
                              <LoadingSpinner />
                            </Td>
                          </Tr>
                        </Tbody>
                      ) : (
                        <>
                          <Tbody {...getTableBodyProps}>
                            {page.map((row, i) => {
                              prepareRow(row);

                              return (
                                <Tr
                                  {...row.getRowProps()}
                                  key={i}
                                  backgroundColor={
                                    entidade === "fila-processamento"
                                      ? props?.selectedRows?.includes(
                                          row.original.id,
                                        )
                                        ? "#16949933"
                                        : "#F0F0F099"
                                      : "white"
                                  }
                                  transition="background-color 0.2s ease"
                                >
                                  {row.cells.map((cell, index) => {
                                    return (
                                      <Td
                                        py="6px"
                                        fontWeight={400}
                                        fontSize="13px"
                                        lineHeight="21.6px"
                                        {...cell.getCellProps()}
                                        key={index}
                                      >
                                        {cell.render("Cell")}
                                      </Td>
                                    );
                                  })}
                                </Tr>
                              );
                            })}
                          </Tbody>
                        </>
                      )}
                    </Table>
                  </Flex>

                  <Flex gap={10} mt="2">
                    {(entidade === "crianca" ||
                      entidade === "relatorio-crianca-adolescente" ||
                      entidade === "relatorio-crianca-adolescente-geral") &&
                      !props?.dashboard && (
                        <Flex alignItems="center" gap={1}>
                          <Box
                            w="4"
                            h="4"
                            bg="#169499"
                            borderRadius="full"
                            border="1px"
                            color="#169499"
                          />
                          <Text>Em Transferência</Text>
                        </Flex>
                      )}

                    {(entidade === "crianca" ||
                      (entidade === "relatorio-pendencia" &&
                        columns?.some(
                          (col) => col?.accessor === "nomeCrianca",
                        )) ||
                      entidade === "crianca-pendencia" ||
                      entidade === "relatorio-crianca-adolescente" ||
                      entidade === "relatorio-crianca-adolescente-geral" ||
                      entidade === `avisos${props?.index}`) && (
                      <Flex alignItems="center" gap={1}>
                        <Box
                          w="4"
                          h="4"
                          bg="red"
                          borderRadius="full"
                          border="1px"
                          color="red"
                        />
                        <Text>Pendência por Maioridade</Text>
                      </Flex>
                    )}
                  </Flex>

                  <TablePagination
                    index={props?.index}
                    nItens={nItens}
                    selecionarTotalItens={selecionarTotalItens}
                    irParaPagina={irParaPagina}
                    pageSize={state.pageSize}
                    setPageSize={setPageSize}
                    rows={rows}
                    totalItems={
                      JSON.parse(sessionStorage.getItem(entidade + "-filter"))
                        ?.totalItems
                    }
                    gotoPage={gotoPage}
                    canPreviousPage={canPreviousPage}
                    previousPage={previousPage}
                    pageOptions={pageOptions}
                    pageIndex={state.pageIndex}
                    canNextPage={canNextPage}
                    nextPage={nextPage}
                    pageCount={pageCount}
                    entidade={entidade}
                    loading={loading}
                  />
                </Flex>
              </Permission>
            </>
          )}
        </Flex>
      </Flex>
    </Flex>
  );
};
